/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");
require("ionicons");
const { createApp } = require("vue");

window.Vue = require("vue").default;
window.$ = require("jquery");

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
// Vue.component(
//     "hms-meet-widget",
//     require("./components/HmsMeetWidget.vue").default
// );
// Vue.component(
//     "context-menu",
//     require("./components/ContextMenu.vue").default
// )

const app = createApp({
    data() {
        return {
            sidebarCollapsed: false,
            csrfToken: document.querySelector('meta[name="csrf-token"]')
                .content,
        };
    },
    created() {
        Echo.channel("PlaysAlert").listen("TaskEvent", (e) => {
            if (e !== null) {
                // console.log("this is e");
                var data = JSON.parse(e.message);
                // console.log(data);

                $.ajax({
                    url: "plays\\get-play-data-by-id",
                    type: "get",
                    data: data,
                    cache: false,
                    success: function (data_on_success) {
                        // console.log("event successfully wait here");
                        LoadUpdatePlay(data_on_success);
                    },
                });
            }
        });
    },
    mounted() {
        if (document.getElementById("app-loader-overlay")?.style) {
            document.getElementById("app-loader-overlay").style.display =
                "none";
        }
    },
});

const files = require.context("./", true, /\.vue$/i);
files.keys().map((key) => {
    return app.component(
        key.split("/").pop().split(".")[0],
        files(key).default
    );
});

app.config.compilerOptions.isCustomElement = (tag) => tag === "ion-icon";

app.mount("#app");

var pStart = { x: 0, y: 0 };
var pStop = { x: 0, y: 0 };

function swipeStart(e) {
    if (typeof e["targetTouches"] !== "undefined") {
        var touch = e.targetTouches[0];
        pStart.x = touch.screenX;
        pStart.y = touch.screenY;
    } else {
        pStart.x = e.screenX;
        pStart.y = e.screenY;
    }
}

function swipeEnd(e) {
    if (typeof e["changedTouches"] !== "undefined") {
        var touch = e.changedTouches[0];
        pStop.x = touch.screenX;
        pStop.y = touch.screenY;
    } else {
        pStop.x = e.screenX;
        pStop.y = e.screenY;
    }

    swipeCheck();
}

function swipeCheck() {
    var changeY = pStart.y - pStop.y;
    var changeX = pStart.x - pStop.x;
    if (isPullDown(changeY, changeX)) {
        window.location.reload();
    }
}

function isPullDown(dY, dX) {
    // methods of checking slope, length, direction of line created by swipe action
    return (
        dY < 0 &&
        ((Math.abs(dX) <= 100 && Math.abs(dY) >= 300) ||
            (Math.abs(dX) / Math.abs(dY) <= 0.3 && dY >= 60))
    );
}

document.addEventListener(
    "touchstart",
    function (e) {
        swipeStart(e);
    },
    false
);
document.addEventListener(
    "touchend",
    function (e) {
        swipeEnd(e);
    },
    false
);
